import { useTranslation } from 'react-i18next';

import deleteWhiteIcon from '../../assets/img/icons/delete_white.svg';
import editWhiteIcon from '../../assets/img/icons/edit-white.svg';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../components/NoDataComponent/NoDataComponent';
import {
  ColoredText,
  CommonFlex,
  CommonImage,
  CommonText,
  Container,
  RoundLetterSection,
  TableText,
} from '../../styledComponents/common';
import { AssignedProjectBox, TableItem } from '../../styledComponents/teams';
import { CommFirstRoundLetterComp } from '../Teams/CommonComponents';
import {
  ButtonsContainer,
  DeleteButton,
  EditButton,
} from './taskLocationButtonStyles';
import {
  TaskLocationsTableHeaderContainer,
  TaskLocationsTableRowContainer,
} from './taskLocationsStyles';

const TaskLocationsTable = props => {
  const { t } = useTranslation();

  const {
    locationsList,
    isLoading,
    handleShowLocation,
    handleEditLocation,
    handleDeleteLocation,
  } = props;

  return (
    <Container style={{ paddingBottom: '20px' }}>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : (
        <>
          <TaskLocationsTableHeaderContainer>
            <TableItem>
              <TableText>{t('location_name')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('office')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('region')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('location_address')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('location_radius')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('actions')}</TableText>
            </TableItem>
          </TaskLocationsTableHeaderContainer>
          {locationsList && locationsList.length > 0 ? (
            locationsList.map((location, index) => (
              <TaskLocationsTableRowContainer key={location.id}>
                <TableItem>
                  <CommFirstRoundLetterComp
                    text={location.name || '-'}
                    backColor={index}
                    underline={false}
                  />
                </TableItem>
                <TableItem>
                  <CommonText>
                    {location.office && location.office.id
                      ? location.office.name
                      : '-'}
                  </CommonText>
                </TableItem>
                <TableItem>
                  <CommonText>
                    {location.region ? t(location.region) : '-'}
                  </CommonText>
                </TableItem>
                <TableItem>
                  <CommonText>{location.address || '-'}</CommonText>
                </TableItem>
                <TableItem>
                  <CommonText>{location.radius} m</CommonText>
                </TableItem>{' '}
                <TableItem>
                  <ButtonsContainer>
                    <ColoredText
                      type="warning"
                      hover
                      onClick={() => handleShowLocation(location)}
                      fontSize="14px"
                      style={{ cursor: 'pointer' }}
                    >
                      {t('see_location')}
                    </ColoredText>
                    <EditButton onClick={() => handleEditLocation(location)}>
                      <CommonImage src={editWhiteIcon} alt="" size="18px" />
                    </EditButton>
                    <DeleteButton
                      onClick={() => handleDeleteLocation(location)}
                    >
                      <CommonImage src={deleteWhiteIcon} alt="" size="14px" />
                    </DeleteButton>
                  </ButtonsContainer>
                </TableItem>
              </TaskLocationsTableRowContainer>
            ))
          ) : (
            <NoDataComponent
              title={t('no_office_locations_found')}
              padding="5vh 0"
              imageHeight="140px"
            />
          )}
        </>
      )}
    </Container>
  );
};
export default TaskLocationsTable;
